import { mapApiRoleToRole } from '../models/roles';
import {
  login as apiLogin,
  logout as apiLogout,
  setAuthToken,
  getAuthToken,
  clearAuthToken,
} from './apiService';

const SESSION_KEY = 'pulso17.session';

/**
 * Traduce el usuario que devuelve la API (id numérico, `roles` como
 * arreglo en español) al modelo interno que usa el resto de la app:
 * un único `role` ya mapeado a nuestro enum `ROLES`.
 */
function normalizeUser(apiUser) {
  return {
    id: String(apiUser.id),
    name: apiUser.name,
    email: apiUser.email,
    sectionId: apiUser.section_id != null ? String(apiUser.section_id) : null,
    role: mapApiRoleToRole(apiUser.roles),
    rawRoles: apiUser.roles,
  };
}

/**
 * Inicia sesión contra la API real (`POST /login`) y persiste el token
 * más el usuario normalizado en localStorage.
 *
 * @param {string} email
 * @param {string} password
 * @returns {Promise<Object>} usuario autenticado, normalizado.
 */
export async function login(email, password) {
  const { token, user } = await apiLogin(email.trim(), password);

  const safeUser = normalizeUser(user);
  setAuthToken(token);
  localStorage.setItem(SESSION_KEY, JSON.stringify(safeUser));

  return safeUser;
}

/**
 * Cierra la sesión: limpia lo local de inmediato (para que la UI
 * reaccione al instante) e intenta avisar al backend en segundo plano.
 */
export function logout() {
  clearAuthToken();
  localStorage.removeItem(SESSION_KEY);
  apiLogout().catch(() => {
    // Si el backend no responde, la sesión ya quedó cerrada localmente.
  });
}

/** Recupera la sesión guardada (si existe y hay token) sin llamar al backend. */
export function getStoredSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw || !getAuthToken()) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
